// extracted by mini-css-extract-plugin
export default {"pt_32":"products_pt_32__CvFXh","search_grid":"products_search_grid__XUTkH"};